 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~intl-relativetimeformat~polyfills","2":"lang_af","3":"lang_ar","4":"lang_be","5":"lang_bg","6":"lang_bs","7":"lang_ca","8":"lang_cs","9":"lang_da","10":"lang_de","11":"lang_el","12":"lang_es","13":"lang_et","14":"lang_fi","15":"lang_fil","16":"lang_fr","17":"lang_he","18":"lang_hi","19":"lang_hr","20":"lang_hu","21":"lang_id","22":"lang_is","23":"lang_it","24":"lang_ja","25":"lang_ka","26":"lang_kk","27":"lang_ko","28":"lang_ky","29":"lang_lt","30":"lang_lv","31":"lang_nl","32":"lang_no","33":"lang_pa","34":"lang_pl","35":"lang_pt","36":"lang_pt_br","37":"lang_ro","38":"lang_ru","39":"lang_sk","40":"lang_sl","41":"lang_sq","42":"lang_sr","43":"lang_sr_me","44":"lang_sv","45":"lang_sw","46":"lang_th","47":"lang_tr","48":"lang_tw","49":"lang_uk","50":"lang_ur","51":"lang_uz","52":"lang_vi","53":"lang_zh_cn","54":"lang_zh_tw","55":"locale_ak","56":"locale_ar","57":"locale_be","58":"locale_bg","59":"locale_bs","60":"locale_ca","61":"locale_cs","62":"locale_da","63":"locale_de","64":"locale_el","65":"locale_en","66":"locale_es","67":"locale_et","68":"locale_fi","69":"locale_fil","70":"locale_fr","71":"locale_he","72":"locale_hi","73":"locale_hr","74":"locale_hu","75":"locale_id","76":"locale_is","77":"locale_it","78":"locale_ja","79":"locale_ka","80":"locale_kk","81":"locale_ko","82":"locale_ky","83":"locale_lt","84":"locale_lv","85":"locale_nl","86":"locale_pa","87":"locale_pl","88":"locale_pt","89":"locale_ro","90":"locale_ru","91":"locale_sk","92":"locale_sl","93":"locale_sq","94":"locale_sr","95":"locale_sr_cyrl_me","96":"locale_sv","97":"locale_sw","98":"locale_th","99":"locale_tr","100":"locale_uk","101":"locale_ur","102":"locale_uz","103":"locale_vi","104":"locale_zh","105":"loclae_af","106":"polyfills","107":"pubnub","111":"vendors~polyfills","112":"vendors~pubnub"}[chunkId]||chunkId) + "." + {"0":"a1edc8bf5cb004a58cc8","2":"7d93998e716f4bb88083","3":"c6b88764cbade5a83c6a","4":"ae697576b3cb7a7729f0","5":"8f99cd00070c752fafd9","6":"8e24ea9e8e672a7647f0","7":"671dffc424c72c092e70","8":"9316030c23b66e220ec0","9":"1e27abc6b0da3d344ef8","10":"09a5f814db4f3925aed7","11":"5b99ade0c984b79fcecb","12":"4860b563decf35ddc8d7","13":"ef09bec6312c010b1d6d","14":"921e68a7a6c6703222ea","15":"3d6723908e502c92e6bf","16":"0e94922caac31ff69a94","17":"a1ddd538fae0e2680506","18":"0bfb058fa77b4e784115","19":"b2e3d0fd4e3b5f1ecc12","20":"b50715ebaf29bba04c01","21":"f75539d0b5193c7eeb3b","22":"20ac36991f8a439a2228","23":"3b7932b9d263df582948","24":"16061bbb907f401a0a32","25":"238e19e605c914d46363","26":"cedafd6ddf2ed50e6b2e","27":"40ac9e0590df7913cedb","28":"29a58d1ec6022b4c48f2","29":"bff1908580bdea85d2aa","30":"b65ff2647acb7171655a","31":"ef5c4726a53e4c71289d","32":"98d239d09a82925396af","33":"cfb30c3128e4609e2586","34":"a827631c63baa1bf10ed","35":"0a0b0e564c5df61bf058","36":"51ebf83eada73fb963b7","37":"56bfe8767373ea8ae4ec","38":"8c4c62a0f3ea814af358","39":"5cf3c6a2fc0221eec8b1","40":"49d9c858a95ad34d9b9d","41":"eb400ecb5e446176d7bf","42":"96b0723c90ff4e0e5613","43":"83ea28909cccdb70f541","44":"2e44e5d0e6a28d292902","45":"04a4c478fd0c6ab78e92","46":"8e55fc7639cfe8750686","47":"8c368edba0bf2071fe8e","48":"de710bcf437bff67e34e","49":"74778f885434c3e3b06f","50":"9987b65369bfa804831c","51":"e765f083d36b8a9f1dab","52":"de6256cf9b672fbeeccb","53":"c2f17d60ed97561ba07d","54":"319e319e2350376cb47c","55":"809d81b353c1feadcbab","56":"da1525731184045aadff","57":"00f81ceb343bc1b3e473","58":"647f759035818d9459e3","59":"eb49e3d280d02423b1f7","60":"67150b3d16d5a32dba32","61":"6b80945ee7aabcead9bc","62":"fad66cecb3af89d9baf4","63":"daf49c2b83cc1da9137a","64":"5b87d111a9e49e6aca2d","65":"1195ebc8391a17efb402","66":"fd2e57390b68a392ff6c","67":"4eb8171fe6217d7d2a5c","68":"ac6aaf53603176381909","69":"8e0c72e07f01e2799168","70":"0f0ebe4a709e2ec6561d","71":"6f00a82cf50eda479327","72":"b5fe738ffbac225c66db","73":"71aa5ba0b3996b8a15e6","74":"e8c1dcfcc5889a30b0e6","75":"2494768afcfa1c7c648f","76":"9e3d5816fbc4acf4460d","77":"c9907e8868f9cc5bedef","78":"45ba9059a3aa03d665be","79":"0db47ad0aa04c98d56e4","80":"94a18cc3b16c44de9b15","81":"2114a8ee4c382ed0972c","82":"cbd8bf6db12e05220503","83":"c3a32ee24899a6b53942","84":"f51d67c86402d9026abc","85":"a4be80dc6f39cfea9bb3","86":"b90c32086f4fd4e9d8be","87":"92a15bc889c6eaa74ddc","88":"c11f8f1e191fceae9ec7","89":"757e816f9e284bf7dfe5","90":"648983b5e48c3b89fd02","91":"b6f250f6397a07a4f16f","92":"59370487c87d8239e118","93":"44a9a9f104c5c1f78b2e","94":"bc454ce452182338613e","95":"2221643d14ca38e81e79","96":"8ef76d8e8d8a7f53c2ed","97":"99c7ac8decba49b821e5","98":"7113b22fb5e422a18e41","99":"42761f4e858cb61fcbc8","100":"9c9132a68df68f366976","101":"d22148b57f320688fb92","102":"74e47e74719ebb522aef","103":"1ed768303bd72ab4ad04","104":"2a092e14aa6323bd3749","105":"cc2f3ba232d750a222b9","106":"34735bc01c292303df7c","107":"6fb70c7d3a704d7cb336","111":"01ed86dee4c453354809","112":"61706ad7e81dac6afb16"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.kustomerapp.com/chat-web/release-v0.1.197/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["kustomer_chat_webpackJsonp"] = window["kustomer_chat_webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 93);
